var React = require('react');

function HeroInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{opacity:0.90;fill:#262626;enable-background:new    ;}\r\n"),React.createElement("polyline",{"className":"st0","points":"-0.3,64.3 -0.3,354.9 610.8,354.9 ","key":1}),React.createElement("polyline",{"className":"st0","points":"609.6,354.9 1921.8,354.9 1921.8,4.8 ","key":2}),React.createElement("path",{"id":"adult-businessman-ceo-618613_1_","className":"st1","d":"M0,64.7c-4.2-8.3,2.5-456.9,2.5-456.9h1920V4.7l-1312.1,350","key":3})]);
}

HeroInline.defaultProps = {"version":"1.1","id":"Шар_1","x":"0px","y":"0px","viewBox":"0 0 1921.8 354.9","style":{"enableBackground":"new 0 0 1921.8 354.9"},"xmlSpace":"preserve"};

module.exports = HeroInline;

HeroInline.default = HeroInline;
